/**
 * Dicionario pt-BR dos textos que chegam da API como codigo ou texto cru (unidade gravada fora do cadastro, como o "Pieces"
 * da importacao XARP). So ACRESCENTAR chaves: a chave e o valor gravado (sem diferenciar caixa) e o texto e o que a tela mostra.
 * Sem texto de tela aqui que dependa de numero: formatacao de numero continua no formatador unico (`lib/format.ts`).
 */
export const PT_BR = {
  'unidade.pieces': 'Peças',
  'salarios.sem_rh_ver': 'O detalhe de salário por pessoa exige a permissão de RH (rh.ver). O total por centro está no mapa de custos.',
} as const;

export type ChavePtBr = keyof typeof PT_BR;

/**
 * Rotulo de uma unidade para a tela: a traducao conhecida (sem diferenciar caixa) ou o proprio texto gravado. Vazio vira "—".
 * Nao muda o valor gravado: so o que aparece em leitura. Campos de edicao continuam com o texto digitado.
 */
export function rotuloUnidade(valor: string | null | undefined): string {
  const bruto = (valor ?? '').trim();
  if (!bruto) return '—';
  const chave = `unidade.${bruto.toLowerCase()}` as ChavePtBr;
  return Object.prototype.hasOwnProperty.call(PT_BR, chave) ? PT_BR[chave] : bruto;
}
